import { createRoute } from "@tanstack/react-router";
import { AuthGuard } from "@/components/auth/AuthGuard";
import { MeetingCardView } from "@/pages/MeetingCardView";
import { Route as RootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/meetings/$meetingId",
  component: MeetingCardRoute,
});

function MeetingCardRoute() {
  const { meetingId } = Route.useParams();
  return (
    <AuthGuard>
      <MeetingCardView meetingId={meetingId} />
    </AuthGuard>
  );
}
